import React from "react";
import { Link } from "react-router-dom";
import logo from "../image/LOGOTASKOPOS.jpg";
import logoPng from "../image/LOGOTASKOPOS1.png";
import { Container } from "react-bootstrap";

const Welcome = () => {
  return (
    <Container className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: "80vh", textAlign: "center" }}>
      <div style={{
        maxWidth: "580px",
        width: "100%",
        padding: "40px 28px",
        borderRadius: "24px",
        background: "rgba(255, 255, 255, 0.96)",
        boxShadow: "0 14px 40px rgba(0,0,0,0.12)",
        border: "1px solid #e0e0e0"
      }}>
        <img
          src={logoPng || logo}
          alt="TASKO POS"
          style={{ maxWidth: "270px", width: "100%", height: "auto", marginBottom: "20px" }}
          onError={(e) => { e.target.src = logo; }}
        />
        <h1 style={{ color: "#1a237e", fontWeight: "bold", fontSize: "1.9rem", marginBottom: "12px" }}>
          BIENVENUE SUR TASKO POS
        </h1>
        <p style={{ color: "#555", fontSize: "1.05rem", marginBottom: "30px" }}>
          Veuillez choisir votre espace d'accès ci-dessous :
        </p>

        <div style={{ display: "flex", justifyContent: "center", gap: "16px", flexWrap: "wrap" }}>
          <Link
            to="/Login"
            style={{
              padding: "14px 30px",
              fontWeight: "bold",
              fontSize: "1rem",
              borderRadius: "14px",
              background: "linear-gradient(135deg, #1e88e5, #1565c0)",
              color: "#ffffff",
              textDecoration: "none",
              boxShadow: "0 4px 14px rgba(30,136,229,0.35)",
              display: "inline-block"
            }}
          >
            🔐 Connexion Application (Login)
          </Link>
          <Link
            to="/CaisseMobile"
            style={{
              padding: "14px 30px",
              fontWeight: "bold",
              fontSize: "1rem",
              borderRadius: "14px",
              background: "#0f172a",
              color: "#ffffff",
              textDecoration: "none",
              boxShadow: "0 4px 14px rgba(15,23,42,0.3)",
              display: "inline-block"
            }}
          >
            📱 Caisse Tactile Caissier
          </Link>
        </div>
      </div>
    </Container>
  );
};

export default Welcome;
